var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"cursor-default",class:{ grouped: _vm.grouped },style:(`margin-left: -${!_vm.first && _vm.grouped ? _vm.size * 0.7 : 0}px`),attrs:{"color":_vm.avatarColor,"size":_vm.size}},[_c('AvatarInnerComponent',{attrs:{"first-name":_vm.firstName,"last-name":_vm.lastName,"profile-image":_vm.profileImage,"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }